import { sysURL } from '../constants';
import { httpClient } from './../utils/HttpClient';
import * as M from '../reducers/settingLabelManage.reducer';

//save data";
export const setSettingLabelManageSaveStateToFetching = () => ({
  type: M.SETTING_LABEL_MANAGE_SAVE_FETCHING,
});

export const setSettingLabelManageSaveStateToFailed = () => ({
  type: M.SETTING_LABEL_MANAGE_SAVE_FAILED,
});

export const setSettingLabelManageSaveStateToSuccess = (payload) => ({
  type: M.SETTING_LABEL_MANAGE_SAVE_SUCCESS,
  payload,
});

export const saveSettingLabel = (data) => {
  let api = 'label/v1/add';
  let url = api;
  return async (dispatch) => {
    try {
      dispatch(setSettingLabelManageSaveStateToFetching());

      let result = await httpClient.post(url, data);

      if (result.data.status == true) {
        dispatch(setSettingLabelManageSaveStateToSuccess(result.data));
      } else {
        dispatch(setSettingLabelManageSaveStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setSettingLabelManageSaveStateToFailed({
          data: { message: error },
        })
      );
    }

    // return getState().SettingPermissionReducer.result.content;
  };
};

//edit,update data ";
export const setSettingLabelManageEditStateToFetching = () => ({
  type: M.SETTING_LABEL_MANAGE_EDIT_FETCHING,
});

export const setSettingLabelManageEditStateToFailed = () => ({
  type: M.SETTING_LABEL_MANAGE_EDIT_FAILED,
});

export const setSettingLabelManageEditStateToSuccess = (payload) => ({
  type: M.SETTING_LABEL_MANAGE_EDIT_SUCCESS,
  payload,
});

export const editSettingLabel = (data) => {
  let api = 'label/v1/update';
  let url = api;
  return async (dispatch) => {
    try {
      dispatch(setSettingLabelManageEditStateToFetching());

      let result = await httpClient.put(url, data);

      if (result.data.status == true) {
        dispatch(setSettingLabelManageEditStateToSuccess(result.data));
      } else {
        dispatch(setSettingLabelManageEditStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setSettingLabelManageEditStateToFailed({
          data: { message: error },
        })
      );
    }

    // return getState().SettingPermissionReducer.result.content;
  };
};

// load Setting Permission By Id
export const setSettingLabelManageByIdStateToFetching = () => ({
  type: M.SETTING_LABEL_MANAGE_BY_ID_FETCHING,
});

export const setSettingLabelManageByIdStateToFailed = () => ({
  type: M.SETTING_LABEL_MANAGE_BY_ID_FAILED,
});

export const setSettingLabelManageByIdStateToSuccess = (payload) => ({
  type: M.SETTING_LABEL_MANAGE_BY_ID_SUCCESS,
  payload,
});

export const loadSettingLabelById = (data) => {
  let api = 'label/v1/getByID?data=' + data;
  let url = api;
  return async (dispatch) => {
    try {
      dispatch(setSettingLabelManageByIdStateToFetching());

      let result = await httpClient.get(url);

      if (result.data.status == true) {
        dispatch(setSettingLabelManageByIdStateToSuccess(result.data));
      } else {
        dispatch(setSettingLabelManageByIdStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setSettingLabelManageByIdStateToFailed({
          data: { message: error },
        })
      );
    }

    // return getState().SettingPermissionReducer.result.content;
  };
};
